var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: { id: "drip-campaign-name-modal", "modal-dialog-size": "md" },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("drip-campaigns.actions.createNewCampaign")) +
                "\n    "
            ),
            _c(
              "span",
              { attrs: { id: "create-drip-campaign-tooltip" } },
              [
                _c("icon", {
                  staticClass: "tooltip-info",
                  attrs: { name: "question-circle" },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("material-input", {
              staticClass: "position-relative",
              attrs: {
                id: "name",
                name: "name",
                "on-type": true,
                label: _vm.$t("drip-campaigns.messages.dripCampaignName"),
              },
              model: {
                value: _vm.name,
                callback: function ($$v) {
                  _vm.name = $$v
                },
                expression: "name",
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: {
                  disabled: _vm.createButtonDisabled,
                  loading: _vm.loading,
                },
                on: { click: _vm.handleCreate, finish: _vm.hideModal },
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("global.words.create")) + "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }